import axios from "axios";
import { toast } from "react-toastify";
import {
  WORKER_FETCH_REQUEST,
  WORKER_FETCH_SUCCESS,
  WORKER_FETCH_FAILURE,
  WORKER_DETAIL,
} from "../../types/HrTypes";

export const loadAllWorkers = (params = {}) => async (dispatch) => {
  dispatch({ type: WORKER_FETCH_REQUEST });
  try {
    const { data } = await axios.get("hr/worker", { params });
    dispatch({ type: WORKER_FETCH_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: WORKER_FETCH_FAILURE, payload: error.message });
  }
};

export const loadWorkerById = (id, params = {}) => async (dispatch) => {
  try {
    const { data } = await axios.get(`hr/worker/${id}`, { params });
    dispatch({ type: WORKER_DETAIL, payload: data });
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
  }
};

export const createWorker = (values) => async () => {
  try {
    const { data } = await axios.post("hr/worker", values);
    toast.success("Worker added");
    return { message: "success", data };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const updateWorker = (id, values) => async () => {
  try {
    const { data } = await axios.put(`hr/worker/${id}`, values);
    toast.success("Worker updated");
    return { message: "success", data };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const deleteWorker = (id, effectiveDate, note) => async () => {
  try {
    await axios.patch(`hr/worker/${id}`, { effective_date: effectiveDate, note });
    toast.warning("Worker deactivated");
    return { message: "success" };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const reactivateWorker = (id, effectiveDate, note) => async () => {
  try {
    await axios.patch(`hr/worker/${id}/reactivate`, { effective_date: effectiveDate, note });
    toast.success("Worker reactivated");
    return { message: "success" };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const addSalaryRevision = (workerId, payload) => async () => {
  try {
    const { data } = await axios.post(`hr/worker/${workerId}/salary-history`, payload);
    toast.success(data.message || "Salary revision added");
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return null;
  }
};
